'use client'

import type { SortFilterItem as SortFilterItemType } from '@/lib/constants'

import { createUrl } from '@/utilities/createUrl'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import React from 'react'

import type { ListItem } from '.'
import type { PathFilterItem as PathFilterItemType } from '.'
import { cn } from '@/utilities/cn'

/** Общий вид пункта фильтра: пилюля, выбранная — чёрная с жёлтым. */
export const filterPill = (active: boolean) =>
  cn(
    'inline-flex h-9 shrink-0 snap-start items-center whitespace-nowrap rounded-full border-2 px-4 font-display text-xs uppercase tracking-wide transition-colors',
    active ? 'border-sun bg-sun text-ink' : 'border-current/30 text-current hover:border-current',
  )

function PathFilterItem({ item }: { item: PathFilterItemType }) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const active = pathname === item.path
  const newParams = new URLSearchParams(searchParams.toString())
  newParams.delete('q')

  return (
    <li>
      <Link className={filterPill(active)} href={createUrl(item.path, newParams)} aria-current={active ? 'true' : undefined}>
        {item.title}
      </Link>
    </li>
  )
}

function SortFilterItem({ item }: { item: SortFilterItemType }) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const active = (searchParams.get('sort') ?? null) === item.slug
  const params = new URLSearchParams(searchParams.toString())

  // сортировку меняем, остальные фильтры сохраняем
  if (item.slug) params.set('sort', item.slug)
  else params.delete('sort')

  return (
    <li>
      <Link
        className={filterPill(active)}
        href={createUrl(pathname, params)}
        prefetch={!active ? false : undefined}
        aria-current={active ? 'true' : undefined}
      >
        {item.title}
      </Link>
    </li>
  )
}

export function FilterItem({ item }: { item: ListItem }) {
  return 'path' in item ? <PathFilterItem item={item} /> : <SortFilterItem item={item} />
}
